module.exports = __webpack_public_path__ + "img/canada-ill-defined-causes-female.cf6dae61.png";